import { UserRole } from '../interfaces/user-role';

export const MANAGEMENT_ROLES: ReadonlySet<UserRole> = new Set<UserRole>([
  UserRole.SUPERVISOR,
  UserRole.MARKETING,
  UserRole.TRAINER,
  UserRole.MANAGER,
  UserRole.HR,
]);

export const REPRESENTATIVE_ROLES: ReadonlySet<UserRole> = new Set<UserRole>([
  UserRole.SALES_REP,
  UserRole.COLLECTOR,
  UserRole.PROMOTER,
  UserRole.SALES_REP_PROMOTER,
]);

export function isManagementRole(
  role: UserRole | null | undefined,
): boolean {
  return role !== null && role !== undefined && MANAGEMENT_ROLES.has(role);
}

export function isRepresentativeRole(
  role: UserRole | null | undefined,
): boolean {
  return role !== null && role !== undefined && REPRESENTATIVE_ROLES.has(role);
}

export function isRole(
  role: UserRole | null | undefined,
  expectedRole: UserRole,
): boolean {
  return role === expectedRole;
}
